export const CONFIG = {
  WHATSAPP_NUMBER: '50685316690', // Editable
  EXPRESS_FEE: 1500, // Editable, in colones
  CURRENCY_SYMBOL: '₡',
  LOGO_URL:
    'https://cdn.magicpatterns.com/uploads/mupTnAiYzPJPXgc2qFEfRm/ChatGPT_Image_15_mar_2026,_13_53_22.png',
  APP_NAME: 'NOIZA',
  APP_TAGLINE: 'Tu Restaurante Inteligente',
  // Operating hours (24h format, local time) — TESTING: disabled
  OPEN_HOUR: 0, // 0:00 AM (disabled for testing)
  CLOSE_HOUR: 24, // 12:00 AM (disabled for testing)
  // KDS Admin PIN (change this to your own PIN)
  ADMIN_PIN: '1234',
}
